import { Component } from "@angular/core";
import { ErrorDialogService } from "@core/components/error-dialog";
import { filter, tap } from 'rxjs/operators';
import { ManageTimeService } from "@core/components/manage-time-session/manage-time-session.service";
import { geolocalizationService } from "@core/services/geolocalization";
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { environment } from "environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {

  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------


  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  /**
  * Constructor
  */
  constructor(
    private _router: Router,
    private _geoS: geolocalizationService,
    private _manageTime: ManageTimeService,
    private connectionService: ConnectionService,
    private _errorDialogService: ErrorDialogService,
    private swUpdate: SwUpdate,

  ) {
    //  idle Start session time
    this._manageTime.startSession();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------
  currentState!: ConnectionState;
  checkConnection = new Subscription();

  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------
  public subscriber: Subscription;

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  ngOnInit(): void {

    /*In ngOnInit, I subscribe to the events router, which is the one that will send you the events every
    * time the navigation starts, and we filter it so that it only sends you when the navigation finishes NavigationEnd */
    this.subscriber = this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (!event['url'].includes('sign-out')) { this._geoS.handlePermission() }
      history.pushState(null, '');
    });

    this.checkConnection.add(
      this.connectionService.monitor().pipe(
        tap((newState: ConnectionState) => {
          this.currentState = newState;

          let dataErrorConect = {
            message: 'No cuentas con conexión al servidor',
            codeError: 408,
            wsName: 'accessWeb'
          };

          if (!this.currentState.hasNetworkConnection) {
            this._errorDialogService.openModalErr(dataErrorConect);
          }

        })
      ).subscribe()
    );


  }
  ngOnDestroy() {

    this.checkConnection.unsubscribe();
    /*In the onDestroy, I validate if my subscriber is still active and unsubscribe,
     if not it will remain active listening when you navigate to another component where you do not require it.*/
    this.subscriber?.unsubscribe();

  }
  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

}
